import * as types from './constants';

// Get Assignments
export const getAssignmentsRequest = data => (
  { type: types.GET_ASSIGNMENTS_REQUEST, payload: data }
);

export const getAssignmentsDone = data => (
  { type: types.GET_ASSIGNMENTS_DONE, payload: data }
);

export const getAssignmentsFailed = errors => (
  { type: types.GET_ASSIGNMENTS_FAILED, payload: errors }
);

export const getAssignmentsReset = () => (
  { type: types.GET_ASSIGNMENTS_RESET }
);

// Operations
export const assignmentsSetPage = data => (
  { type: types.ASSIGNMENTS_SET_PAGE, payload: data }
);